import { infoIcon } from '@y42/feature/icons';
import { Binding, GraphObject, Margin, Node, Panel, Picture, Size, Spot, TextBlock } from 'gojs';
import { dataLineageDiagramConfig } from '../../../../../state/data-lineage-diagram';

const $ = GraphObject.make;

export const emptyNodeTemplate = () =>
  $(
    Node,
    Node.Horizontal,
    {
      selectable: false,
      deletable: false,
    },
    $(
      Panel,
      Panel.Horizontal,
      {
        margin: new Margin(5, 0, 5, 0),
      },
      placeholderLogo(),
      placeholderText(),
    ),
  );

const placeholderLogo = () =>
  $(
    Picture,
    {
      desiredSize: new Size(20, 20),
      imageStretch: GraphObject.Uniform,
      margin: new Margin(0, 10, 0, 0),
    },
    logoBinding(),
  );

const placeholderText = () =>
  $(TextBlock, {
    alignment: Spot.Left,
    stroke: dataLineageDiagramConfig.colors.grey,
    font: `${dataLineageDiagramConfig.font.style} ${dataLineageDiagramConfig.font.size.big} ${dataLineageDiagramConfig.font.family}`,
    overflow: TextBlock.OverflowClip,
    width: 170,
    text: 'There is no data',
  });

const logoBinding = () => new Binding('source', '', () => infoIcon);
